import React, { useEffect, useRef } from 'react';
import SearchBox from '../common/SearchBox';

import heroBg from '../../assets/img/hero/hero-layout1-bg.png';
import heroSun from '../../assets/img/icons/hero-sun.png';

const Hero = () => {
    const elementsRef = useRef([]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const element = entry.target;
                        const delay = element.getAttribute('data-delay');

                        setTimeout(() => {
                            element.style.opacity = '1';
                            element.style.transform = 'translateY(0) scale(1)';
                            element.style.visibility = 'visible';
                        }, (parseFloat(delay) || 0) * 1000);
                    }
                });
            },
            { threshold: 0.1 }
        );

        elementsRef.current.forEach(element => {
            if (element) observer.observe(element);
        });

        return () => observer.disconnect();
    }, []);

    const addToRefs = (el) => {
        if (el && !elementsRef.current.includes(el)) {
            elementsRef.current.push(el);
        }
    };

    return (
        <section
            className="z-index-common hero-layout1 overflow-clip"
            style={{
                backgroundImage: `url(${heroBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                position: 'relative',
                padding: '100px 0',
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            <div className="container-fluid p-xl-0">
                <div className="row justify-content-center">
                    <div className="col-xl-10 col-xxl-7">
                        <div className="hero-content text-center">
                            {/* Sun Icon */}
                            <img
                                ref={addToRefs}
                                className="fade-anim"
                                data-delay="0.70"
                                src={heroSun}
                                alt="icon"
                                style={{
                                    opacity: 0,
                                    transform: 'scale(0.8)',
                                    transition: 'all 0.8s ease 0.7s',
                                    marginBottom: '30px',
                                    maxWidth: '100px',
                                    visibility: 'hidden',
                                    color:'#f7921f',
                                }}
                            />

                            {/* Title Area */}
                            <div className="title-area text-center">
                                <span
                                    ref={addToRefs}
                                    className="sec-subtitle mb-0 fade-anim"
                                    data-delay="0.75"
                                    data-direction="bottom"
                                    style={{
                                        display: 'block',
                                        opacity: 0,
                                        transform: 'translateY(30px)',
                                        transition: 'all 0.8s ease 0.75s',
                                        color: '#fff',
                                        fontSize: '18px',
                                        fontWeight: '500',
                                        marginBottom: '15px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '1px',
                                        visibility: 'hidden'
                                    }}
                                >
                                    about Ascend Travel Solutions
                                </span>
                                <h1
                                    ref={addToRefs}
                                    className="sec-title text-white-color fade-anim"
                                    data-delay="0.76"
                                    data-direction="top"
                                    style={{
                                        opacity: 0,
                                        transform: 'translateY(30px)',
                                        transition: 'all 0.8s ease 0.76s',
                                        color: '#fff',
                                        fontSize: 'clamp(2.5rem, 5vw, 4.5rem)',
                                        fontWeight: '700',
                                        lineHeight: '1.2',
                                        marginBottom: '40px',
                                        textShadow: '2px 2px 8px rgba(0,0,0,0.5)',
                                        visibility: 'hidden'
                                    }}
                                >
                                    Find your holiday <br className="d-none d-xxl-block" />
                                    with us
                                </h1>
                            </div>

                            {/* Search Box */}
                            <div
                                ref={addToRefs}
                                style={{
                                    opacity: 0,
                                    transform: 'translateY(30px)',
                                    transition: 'all 0.8s ease 0.77s',
                                    visibility: 'hidden'
                                }}
                            >
                                <SearchBox />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;